import React, { useEffect, useState } from "react";
import "./TextQuery.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "react-phone-input-2/lib/style.css";
import url from "../../Utility/URL/url";
import useRazorpay from "react-razorpay";
import constant from "../../Utility/Constants/constant";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import Loader from "../../Utility/loader/Loader";
import FourZeroFour from "../../Utility/ErrorPages/FourZeroFour/FourZeroFour";
import defaultProfilePic from "../../Utility/images/profilepic.jpg";
import { getPriceUtility } from "../../Utility/Price/getPriceUtility";
import { getAdvisorDetails } from "./SearchServiceFromDb/SearchServiceFromDB";

// ✅ Reusable API function
// const getAdvisorDetails = (username, id) => {
//   // console.log(`[API CALLED in TextQuery]`, { username, id });
//   return axios.get(
//     `${url.GET_SERVICE_BY_USERNAME_AND_PLATFORMSERVICEID}${id}?username=${username}`
//   );
// };

export default function TextQuery() {
  const Razorpay = useRazorpay();
  const location = useLocation();
  const navigate = useNavigate();
  const { username, id } = useParams();

  // 🔹 First declare all states
  const [serviceInformation, setServiceInformation] = useState();
  const [advisorInformation, setAdvisorInformation] = useState();
  const [errors, setErrors] = useState({});
  const [phone, setPhone] = useState();
  const [loader, setLoader] = useState(true);
  const [fourZeroFour, setFourZeroFour] = useState(false);
  const [serviceFeedback, setServiceFeedback] = useState([]);
  const [index, setIndex] = useState(0);

  const advisorInfo = advisorInformation;

  const nextReview = () => {
    if (index + 2 < serviceFeedback.length) {
      setIndex(index + 2);
    }
  };

  const prevReview = () => {
    if (index - 2 >= 0) {
      setIndex(index - 2);
    }
  };

  const EllipsisWithTooltip = ({ text }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        className="ellipsis-text"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {text}
        {isHovered && <div className="custom-tooltip">{text}</div>}
      </div>
    );
  };
  const StarRating = ({ totalStars = 5, rating = 0 }) => {
    const renderStars = () => {
      return Array.from({ length: totalStars }, (_, index) => {
        const starIndex = index + 1;
        const isFilled = starIndex <= rating;

        return (
          <svg
            key={index}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill={isFilled ? "#FFD700" : "#D3D3D3"}
            style={{ width: "15px", height: "15px" }}
          >
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
        );
      });
    };

    return <div className="d-flex">{renderStars()}</div>;
  };
  const [formInformation, setFormInformation] = useState({
    username: "",
    email: "",
    query: "",
  });

  let paymentFailedStatus = false;

  useEffect(() => {
    getAdvisorDetails(username, id)
      .then((res) => {
        const { serviceData, profileData, availability, userReviews } =
          res.data;

        setServiceInformation(serviceData);
        setAdvisorInformation({ serviceData, profileData, availability, userReviews });

        // Filter feedback **only if serviceData exists**
        const filteredFeedback = (userReviews || []).filter(
          (review) =>
            review.platformServiceId === serviceData?.platformServiceId
        );

        setServiceFeedback(filteredFeedback);
        setLoader(false);

        console.log("Filtered Feedback:", filteredFeedback); // ✅ check in console
      })
      .catch((err) => {
        console.error("API Error in TextQuery", err);
        setFourZeroFour(true);
        setLoader(false);
      });
  }, [username, id]);

  const validateAllFields = () => {
    let errors = {};

    errors.username = !formInformation.username ? "Name is mandatory!" : "";

    if (!formInformation.email) {
      errors.email = "Email is mandatory!";
    } else {
      const emailRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (!emailRegex.test(formInformation.email)) {
        errors.email = "Invalid email format";
      }
    }

    errors.phone = !phone ? "Phone Number is mandatory!" : "";
    errors.query = !formInformation.query
      ? "Please enter the query you want to ask"
      : "";

    return errors;
  };

  function filterFeedBack(userReviews) {
    if (!userReviews || !serviceInformation) return [];
    return userReviews.filter(
      (review) =>
        review.platformServiceId + "" ===
        serviceInformation.platformServiceId + ""
    );
  }

  // 🔽 Keep your full payment logic as-is
  const handlePayment = () => {
    if (!serviceInformation || !advisorInformation) {
      toast.error("Service information not loaded yet");
      return;
    }

    if (serviceInformation.price === "0" || serviceInformation.price === 0) {
      axios
        .post(url.POST_QUERY_TO_ADVISOR, {
          advisorUsername: advisorInformation.profileData.username,
          advisorName: advisorInformation.profileData.fullName,
          platformServiceId: serviceInformation.platformServiceId,
          cxEmail: formInformation.email,
          cxName: formInformation.username,
          phoneNumber: phone,
          paymentStatus: "FREE",
          paymentId: null,
          title: serviceInformation.title,
          queryContent: formInformation.query,
          price: serviceInformation.price,
        })
        .then((response) => {
          toast.success("Query is added to the advisor profile.", {
            position: toast.POSITION.TOP_CENTER,
          });

          const bookingConfirmationData = {
            title: serviceInformation.title,
            calendar: "text_query",
            advisorInformation: advisorInformation,
          };
          const { bookingId } = response.data;
          navigate(
            `/${serviceInformation.platformServiceId}/bookingConfirmation/bookingId=${bookingId}`,
            {
              state: bookingConfirmationData,
            }
          );
        })
        .catch((error) => console.log(error));
    } else {
      //  Paid flow (same as your code)
      axios
        .post(url.POST_PAY_CREATE_ORDER, {
          amount: serviceInformation.price,
          currency: advisorInformation.profileData.currency,
          platformServiceId: serviceInformation.platformServiceId,
          name: formInformation.username,
          emailId: formInformation.email,
          mobileNumber: phone,
          usernameAdvisor: advisorInformation
            ? advisorInformation.profileData.username
            : "",
        })
        .then((response) => {
          const usernameCustomer = response.data.usernameCustmr;
          if (response.status === 200) {
            const options = {
              key: constant.RAZORPAY_key,
              amount: response.data.amount,
              currency: advisorInformation.profileData.currency,
              name: constant.COMPANY_NAME,
              description: serviceInformation.title,
              image: constant.COMPANY_LOGO,
              order_id: response.data.orderId,
              handler: function (response) {
                axios
                  .post(url.POST_PAYMENT_PAY_RESPONSE, {
                    orderId: response.razorpay_order_id,
                    paymentId: response.razorpay_payment_id,
                    status: constant.PAYMENT_RESPONSE_STATUS_SUCCESS,
                    paymentStatus: constant.PAYMENT_STATUS_PAID,
                    usernameAdvisor: advisorInformation
                      ? advisorInformation.profileData.username
                      : "",
                    cxUsername: usernameCustomer,
                  })
                  .then((response) => {
                    const paymentStatus = response.data.paymentStatus;
                    const paymentId = response.data.paymentId;

                    if (paymentStatus === "PAID") paymentFailedStatus = true;
                    axios
                      .post(url.POST_QUERY_TO_ADVISOR, {
                        advisorUsername:
                          advisorInformation.profileData.username,
                        advisorName: advisorInformation.profileData.fullName,
                        platformServiceId: serviceInformation.platformServiceId,
                        cxEmail: formInformation.email,
                        cxName: formInformation.username,
                        phoneNumber: phone,
                        paymentStatus: paymentStatus,
                        paymentId: paymentId,
                        title: serviceInformation.title,
                        queryContent: formInformation.query,
                        price: serviceInformation.price,
                        usernameAdvisor: advisorInformation
                          ? advisorInformation.profileData.username
                          : "",
                        cxUsername: usernameCustomer,
                      })
                      .then((response) => {
                        toast.success("Query is sent to the advisor profile.", {
                          position: toast.POSITION.TOP_CENTER,
                        });

                        const bookingConfirmationData = {
                          title: serviceInformation.title,
                          calendar: "text_query",
                          advisorInformation: advisorInformation,
                        };
                        const { bookingId } = response.data;
                        navigate(
                          `/${serviceInformation.platformServiceId}/bookingConfirmation/bookingId=${bookingId}`,
                          {
                            state: bookingConfirmationData,
                          }
                        );
                      })
                      .catch((error) =>
                        toast.warning(error, {
                          position: toast.POSITION.TOP_RIGHT,
                        })
                      );
                  })
                  .catch((error) => {});
              },
              prefill: {
                name: formInformation.username,
                email: formInformation.email,
                contact: phone,
              },
              notes: {
                address: "",
              },
              theme: {
                color: "#3399cc",
              },
              modal: {
                ondismiss: async function () {
                  if (!paymentFailedStatus) {
                    const orderId = response.data.orderId;
                    try {
                      const response = await axios.post(
                        url.POST_PAYMENT_PAY_RESPONSE,
                        {
                          orderId: orderId,
                          paymentId: null,
                          status: constant.CANCELED_BY_USER,
                          paymentStatus: constant.CANCELED_BY_USER,
                        }
                      );

                      if (response.status === 200) {
                        toast.warn("Your booking is not created....");
                      }
                    } catch (error) {
                      // console.log("I am in error");
                      toast.error("Server error", {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }
                },
              },
            };

            const rzp1 = new Razorpay(options);

            rzp1.on("payment.failed", function (response) {
              paymentFailedStatus = true;
              toast.error("Payment Failed try again after sometime..!", {
                position: toast.POSITION.TOP_RIGHT,
              });

              const orderId = response.error.metadata.order_id;
              const paymentId = response.error.metadata.payment_id;

              axios
                .post(url.POST_PAYMENT_PAY_RESPONSE, {
                  orderId: orderId,
                  paymentId: paymentId,
                  status: constant.PAYMENT_RESPONSE_STATUS_FAIL,
                  paymentStatus: constant.PAYMENT_STATUS_FAILED,
                })
                .then((response) => {
                  // console.log("Payment fail api");
                })
                .catch((error) => {
                  axios
                    .post(url.POST_PAYMENT_PAY_RESPONSE, {
                      orderId: orderId,
                      paymentId: paymentId,
                      status: constant.PAYMENT_RESPONSE_STATUS_ERROR,
                      paymentStatus: constant.PAYMENT_STATUS_FAILED,
                    })
                    .then((res) => console.log(res));
                });
            });

            rzp1.open();
          }
        });
    }
  };

  function handleSubmit() {
    let errors = validateAllFields();
    let keys = Object.keys(errors);
    let count = keys.reduce((acc, curr) => (errors[curr] ? acc + 1 : acc), 0);

    if (count === 0) {
      handlePayment();
    } else {
      setErrors((preValue) => (preValue !== errors ? errors : preValue));
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setFormInformation((prevState) => ({ ...prevState, [name]: value }));
  }
  
  function goBackToPreviousPage() {
    navigate(-1);
  }


  function returnProfilePicString() {
    //if the image comes with the profileData then return the image.
    //also check wether it's a image name or the url the backend can contain anything .
    //if its a url then show the return the url else show the image name with.png

    //if it's not available then return the default pic.

    if (advisorInfo) {
      if (advisorInfo.profileData.profilePic) {
        const url = advisorInfo.profileData.profilePic;

        if (isValidUrl(url)) {
          return url;
        } else {
          try {
            const image = require(`../../Utility/images/${url}`);
            return image;
          } catch (error) {
            return defaultProfilePic;
          }
        }
      } else {
        return defaultProfilePic;
      }
    }
  }
  const isValidUrl = (urlString) => {
    try {
      return Boolean(new URL(urlString));
    } catch (e) {
      return false;
    }
  };

  if (loader) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Loader />
      </div>
    );
  }

  if (fourZeroFour) {
    return <FourZeroFour />;
  }

  return (
    <div className="text-query">
      <div
        className="container"
        style={{
          background: "white",
          borderRadius: "16px",
          boxShadow: " 0 4px 6px -1px rgba(0, 0, 0, 0.1)",
          maxWidth: "900px",
          width: "100%",
          display: "grid",
          gridTemplateColumns: "1fr 1.2fr",
          overflow: "hidden",
          border: "1px solid #eeeeeead",
          padding: "0",
           margin:'auto',
        }}
      >
        <div className="info-panel" style={{position:'relative'}}>
          <div className="flex-item" onClick={goBackToPreviousPage}>
                  <span className="Go-back border rounded border-2 px-1" style={{position:'absolute', top:'15px',left:'15px', padding:'0px 5px !important', height:'27px'}}>
                    <i className="fa-solid fa-arrow-left" style={{color:'white'}}></i>
                  </span>
                </div>
          <div className="d-flex align-items-center gap-3 mb-4" >
            
            <div className="flex-item">
              <img
                className="rounded-circle"
                src={returnProfilePicString()}
                alt="Avatar"
                style={{ width: "90px", height: "90px" }}
              />
            </div>
            <div className="flex-item">
              <span className="service-user-name" style={{ fontSize: "26px" }}>
                {advisorInfo.profileData.fullName}
              </span>
            </div>
          </div>
       
          <div>
            <h1>{advisorInfo.serviceData.title}</h1>
            <span
  dangerouslySetInnerHTML={{ __html: advisorInfo.serviceData.description }}
/>
            
          </div>
          <div className="d-flex my-1">
            <div
              className="service-duration text-center p-2 "
              style={{ background: "#c9fcdcfa" , border:'3px solid #25ee72'}}
            >
              <div className="booking-minutes-footer">
                <i className="fa-solid fa-stopwatch text-black pr-2"></i>
                 {serviceInformation.type !== "TEXT_QUERY" && (
                                      <>{serviceInformation.callDuration} min</>
                                    )}
                                    {serviceInformation.type === "TEXT_QUERY" && (
                                      <>Answer in 2 days</>
                                    )}
              </div>
            </div>
            <div
              className="service-charge text-center p-2 ml-2"
              style={{ background: "#f7fd91f0", border:'3px solid #ecf805' }}
            >
              <div className="booking-price-footer">
                <i className="fa-solid fa-money-bill text-black pr-2"></i>
                <span >
                  {getPriceUtility(
                    advisorInfo.profileData.currency,
                    serviceInformation.price
                  )}
                </span>
              </div>
            </div>
          </div>
          {/* feedbacks */}

          {serviceFeedback.length === 0 ? (
            ""
          ) : (
            <div className="feedback-container " >
              {/* <div className="row">
                <span className="feedback-title pb-3 pt-lg-0 pt-3">
                  Reviews
                </span>
              </div> */}

              <div className="slider-section">
                <div className="">
                  <div className="review-container" style={{ padding: " 8px 15px" }}>
                    {/* Navigation Arrows */}
                    <div className="controls">
                      <button
                        className={`arrow ${index === 0 ? "disabled" : ""}`}
                        onClick={prevReview}
                        disabled={index === 0}
                        style={{ width: "30px", height: "30px" }}
                      >
                        <i className="fa-solid fa-angle-left"></i>
                      </button>
                      <button
                        className={`arrow ${
                          index + 2 >= serviceFeedback.length ? "disabled" : ""
                        }`}
                        onClick={nextReview}
                        disabled={index + 2 >= serviceFeedback.length}
                        style={{ width: "30px", height: "30px" }}
                      >
                        <i className="fa-solid fa-angle-right"></i>
                      </button>
                    </div>
                    <div className="review-wrapper">
                      {serviceFeedback
                        .slice(index, index + 2)
                        .map((review, i) => (
                          <div key={i} className="user-review" style={{margin:'5px 0'}}>
                            <div className="card-title">
                              <div className="feedback-title feedback-name-of-person">
                                <div className="d-flex flex-column justify-content-start align-items-start">
                                  <div className="font-weight-bold fs-6 mr-3">
                                    {review.name}
                                  </div>
                                  <StarRating
                                    totalStars={5}
                                    rating={Math.round(review.rating)}
                                  />
                                </div>
                              </div>
                            </div>
                            <p className="card-text pt-1">
                              <EllipsisWithTooltip text={review.description} />
                            </p>
                          </div>
                        ))}
                    </div>
                  </div>
                  {/* <div className="d-flex justify-content-start">
                      <button className="see-all">See all reviews</button>
                    </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
        

        <div className="form-panel">
          <div className="form-header">
            <h2>Let's Connect</h2>
            <p>Send me a message about your project</p>
          </div>
          <div className="form-group">
            {/* <div className="username-field"> */}
            <label className="form-label">Name</label>
            <input
              type="username"
              className="form-control"
              name="username"
              placeholder="Your name"
              onChange={handleChange}
              value={formInformation.username}
            />
            {errors.username && (
              <span className="text-danger">{errors.username}</span>
            )}
          </div>
          <div className="form-group">
            {/* <div className="email-field"> */}
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="your@email.com"
              onChange={handleChange}
              value={formInformation.email}
            />
            {errors.email && (
              <span className="text-danger">{errors.email}</span>
            )}
          </div>

          <div className="form-group">
            <label className="form-label martop">Phone</label>
            <div className="phone-group">
              <PhoneInput
                country={"in"} // default country
                value={phone}
                onChange={setPhone}
                placeholder="Mobile number"
                containerClass="custom-phone-container"
                inputClass="custom-phone-input"
                buttonClass="custom-flag-button"
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: true,
                }}
              />
              {errors.phone && (
                <span className="text-danger">{errors.phone}</span>
              )}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Message</label>
            <textarea
              className="form-control"
              name="query"
              placeholder="Tell me about your project.."
              type="text"
              onChange={handleChange}
              value={formInformation.query}
            />
            {errors.query && (
              <span className="text-danger">{errors.query}</span>
            )}
          </div>

          <button className="submit-btn" onClick={handleSubmit}>
            Send Message
          </button>
        </div>
      </div>
    </div>
  );
}
